






























































































































import {Component, Vue} from "vue-property-decorator";
import AppFooter from "../../layout/AppFooter.vue";
import Menu from "../../layout/Menu.vue";

@Component({
    components: {
        AppFooter,
        Menu,
    }
})

export default class UserLayout extends Vue {
    color : String = 'blue';
    mode:String = '';
    snackbar:Boolean = false;
    text: string =  'Ana Sayfaya gitmek istiyor musunuz?';
    timeout: number = 3000;
    x: string | null = null;
    y: string | null = 'top';
    drawer: any = null;
    /** Artırılınca şube seçici yeniden çizilir (iptalde eski şubeye dönsün) */
    siteSelectKey: number = 0;

    /** Şube seçicideki seçenekler */
    get siteOptions(){
        return this.$store.getters.sites.map((site:any)=>({
            text: site.name + (Number(site.enabled) === 1 ? "" : " (yayında değil)"),
            value: Number(site.site_id),
        }));
    }

    /**
     * "Siteye Git" aktif şubenin sitesini açar. Yerelde canlı alan adına
     * değil http://<site_key>.localhost:<yerel API portu>/ adresine gider;
     * yerelde yapılan değişiklik canlı sitede aranıp "yansımadı" sanılmasın.
     */
    get activeSiteUrl(){
        return this.$store.getters.activeSiteUrl;
    }

    async onSiteChange(siteId:number){
        const changed = await this.$store.dispatch("changeSite", siteId);
        if(changed === false){
            // Kullanıcı kaydedilmemiş değişiklik uyarısında vazgeçti
            this.siteSelectKey++;
        }
    }

    setTheme(){
        localStorage.setItem("themeDark", this.$vuetify.theme.dark.toString());
    }
    created(){
        this.$vuetify.theme.dark = localStorage.getItem("themeDark") == "true";
        // Giriş formundan gelindiğinde authInit çalışmıyor; şube listesi
        // (ve adrese göre aktif şube) burada da yüklenir.
        if(!this.$store.getters.sitesLoaded){
            this.$store.dispatch("loadSites");
        }
    }
};
